import React, { useMemo } from 'react';
import { Card, Row, Col, Typography } from 'antd';
import { CloudOutlined } from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;

function APIDocs() {
    // Detect environment based on hostname
    const isDevEnvironment = useMemo(() => {
        const hostname = window.location.hostname;
        return hostname.includes('-dev.') || hostname.includes('localhost');
    }, []);

    // Define applications with their dev and production servers
    const applications = [
        {
            name: 'Lunajoy Portal (Foundation)',
            icon: <CloudOutlined />,
            color: '#00d4aa', // Tech Teal
            dev: {
                url: 'https://api.portal-dev.hellolunajoy.com/api-docs'
            },
            prod: {
                url: 'https://api.portal.hellolunajoy.com/api-docs'
            }
        },
        {
            name: 'Provider API',
            icon: <CloudOutlined />,
            color: '#8b5cf6', // Tech Purple
            dev: {
                url: 'https://yujm3bgmyp.us-east-1.awsapprunner.com/api-docs',
            },
            prod: {
                url: 'https://vwirtmd324.us-east-1.awsapprunner.com/api-docs',
            }
        },
        {
            name: 'Forms (Assessments)',
            icon: <CloudOutlined />,
            color: '#6366f1', // Modern Indigo
            dev: {
                url: 'https://api.forms-dev.hellolunajoy.com/api-docs'
            },
            prod: {
                url: 'https://api.forms.hellolunajoy.com/api-docs'
            }
        },
        {
            name: 'Referral',
            icon: <CloudOutlined />,
            color: '#1890ff', // Tech Blue
            dev: {
                url: 'https://referral-dev.hellolunajoy.com/api-docs'
            },
            prod: {
                url: 'https://referral.hellolunajoy.com/api-docs'
            }
        }
    ];

    const handleOpenSwagger = (url) => {
        window.open(url, '_blank', 'noopener,noreferrer');
    };

    return (
        <div style={{ 
            padding: '24px', 
            minHeight: '100vh',
            backgroundColor: '#ffffff'
        }}>
            <div style={{ 
                maxWidth: '1400px', 
                margin: '0 auto'
            }}>
                <div style={{ 
                    marginBottom: '32px',
                    textAlign: 'center'
                }}>
                    <Title level={1} style={{ 
                        color: '#1a1a1a', 
                        marginBottom: '16px',
                        fontSize: '2.5rem',
                        fontWeight: '700'
                    }}>
                        API Documentation
                    </Title>
                    <Paragraph style={{ 
                        fontSize: '18px', 
                        color: '#4a4a4a',
                        maxWidth: '600px',
                        margin: '0 auto',
                        lineHeight: '1.6',
                        fontWeight: '500'
                    }}>
                        Access comprehensive API documentation for all our services and environments. 
                        Click on any card to explore the interactive documentation.
                    </Paragraph>
                </div>

                <Row gutter={[24, 24]}>
                    {applications.map((app, appIndex) => {
                        const currentUrl = isDevEnvironment ? app.dev.url : app.prod.url;
                        
                        return (
                            <Col xs={24} sm={12} lg={6} key={appIndex}>
                                <Card
                                    hoverable
                                    style={{
                                        height: '180px',
                                        borderRadius: '12px',
                                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                                        border: '2px solid #e8e8e8',
                                        transition: 'all 0.3s ease'
                                    }}
                                    bodyStyle={{
                                        padding: '20px',
                                        height: '100%',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'space-between'
                                    }}
                                    onClick={() => handleOpenSwagger(currentUrl)}
                                >
                                    <div>
                                        <div style={{ 
                                            display: 'flex', 
                                            alignItems: 'center',
                                            marginBottom: '12px'
                                        }}>
                                            <div style={{ 
                                                fontSize: '24px', 
                                                marginRight: '10px',
                                                color: app.color
                                            }}>
                                                {app.icon}
                                            </div>
                                            <Title level={4} style={{ 
                                                margin: 0, 
                                                color: '#1a1a1a',
                                                fontSize: '16px',
                                                fontWeight: '700'
                                            }}>
                                                {app.name}
                                            </Title>
                                        </div>
                                        
                                        <Text style={{ 
                                            fontSize: '12px',
                                            color: '#1890ff',
                                            wordBreak: 'break-all',
                                            lineHeight: '1.4',
                                            cursor: 'pointer'
                                        }}>
                                            {currentUrl}
                                        </Text>
                                    </div>
                                </Card>
                            </Col>
                        );
                    })}
                </Row>
            </div>
        </div>
    );
}

export default APIDocs;
